import React, { useEffect, useRef, useState } from "react";
import DownloadDropdown from "./Download/DownloadDropdown";

const CHANNEL_NAME = "downloads-sync";
const STORAGE_KEY = "dowloadsData";

export const GenericDownload = ({ isOpen, onClose }) => {
  const wrapperRef = useRef(null);
  const [downloadsData, setDownloadsData] = useState({});
  const lastSessionValueRef = useRef("");

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose?.();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);

  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);


    channel.onmessage = (event) => {
      const { type, payload } = event.data || {};

      if (type === "SYNC_DOWNLOADS" && payload) {
        sessionStorage.setItem(STORAGE_KEY, payload);
        setDownloadsData(JSON.parse(payload));
        lastSessionValueRef.current = payload;
      } else if (type === "INITIAL_SYNC" && payload) {
        sessionStorage.setItem(STORAGE_KEY, payload);
        setDownloadsData(JSON.parse(payload));
        lastSessionValueRef.current = payload;
      } else if (type === "REQUEST_INITIAL_SYNC") {
        const current = sessionStorage.getItem(STORAGE_KEY) || "{}";
        if (current !== "{}") {
          channel.postMessage({ type: "INITIAL_SYNC", payload: current });
        }
      }
    };

    const initialStored = sessionStorage.getItem(STORAGE_KEY) || "{}";
    if (initialStored === "{}") {
      channel.postMessage({ type: "REQUEST_INITIAL_SYNC" });
    } else {
      lastSessionValueRef.current = initialStored;
      setDownloadsData(JSON.parse(initialStored));
    }

    const interval = setInterval(() => {
      const stored = sessionStorage.getItem(STORAGE_KEY) || "{}";
      if (stored !== lastSessionValueRef.current) {
        lastSessionValueRef.current = stored;
        setDownloadsData(JSON.parse(stored));
      }
    }, 500);

    return () => {
      clearInterval(interval);
      channel.close();
    };
  }, []);

  return (
    <>
      {isOpen && Object.keys(downloadsData)?.length > 0 && (
        <div ref={wrapperRef}>
          <DownloadDropdown data={downloadsData} open={isOpen} />
        </div>
      )}
    </>
  );
};
